export const NO_DESC_CODIGO = 'NoDesc';

export function isNoDescCodigo(codigo) {
    return codigo?.toString().trim().toLowerCase() === NO_DESC_CODIGO.toLowerCase();
}

export function isNoDescMaterial(material) {
    if (!material) return false;
    if (material.noRequiereMateriales) return true;
    if (isNoDescCodigo(material.codigo)) return true;
    if (isNoDescCodigo(material.codigos)) return true;
    return false;
}

export function filterMaterialesVisibles(materiales = []) {
    return (materiales || []).filter((material) => !isNoDescMaterial(material));
}
